<template>
    <div class="regicall-index-container">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
      props: {

      },
      data () {
        return {
        };
      },
      computed: {

      }
    };
</script>

<style lang="scss">
    .regicall-index-container {
        h3 {
            font-size: 1.6em;
        }
    }
</style>
